module.exports = __webpack_public_path__ + "static/flags/HR-9f79b2a8344e8420307b5bc2784c261a.gif";